<template>
	<type-wrapper class="type-N" limit v-if="iframeUrl">
		<iframe class="type-N-iframe" :src="iframeUrl" frameBorder="0" width="100%" height="100%"></iframe>
	</type-wrapper>
</template>

<script>
	// 3D模型显示框
	import mixin from '../mixin.js'
	export default {
		name: 'type-N',
		mixins: [ mixin ],
		computed: {
			iframeUrl() {
				return this.showData.url || '';
			}
		}
	}
</script>

<style scoped lang="less">
	.type-N{
		height: 45vh;
        .type-N-iframe:hover{
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }
	}
</style>
